import { getCurrentDevice } from './utils';

import moment from 'moment';
import Pikaday from 'pikaday';

moment.locale($('html').attr('lang'));

const format = 'MM/DD/YYYY';

function checkValue(str, max) {
	if (str.charAt(0) !== '0' || str == '00') {
		let num = parseInt(str);

		if (isNaN(num) || num <= 0 || num > max) {
			num = 1;
		}

		str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
	};

	return str;
};

function manualFormat(input) {
	let value = input.value;

	if (/\D\/$/.test(value)) {
		value = value.substr(0, value.length - 3);
	}

	let values = value.split('/').map(function(v) {
		return v.replace(/\D/g, '')
	});

	if (values[0]) {
		values[0] = checkValue(values[0], 12);
	}
	if (values[1]) {
		values[1] = checkValue(values[1], 31);
	}

	const output = values.map(function(item, index) {
		return item.length == 2 && index < 2 ? item + ' / ' : item;
	});

	input.value = output.join('').substr(0, 14);
}

export const initManualFormat = (field) => {
	$(field).on('input', function(event) {
		const code = event.keyCode;

		if ( code != 37 && code != 38 && code != 39 && code != 40 ) {
			manualFormat(this);
		}
	});
}

export default function datepickerUI() {
	let isKeyboard = false;

	document.querySelectorAll('.js-datepicker-single').forEach(field => {
		new Pikaday({
			minDate: new Date(),
			field,
			format,
			container: field.parentNode
		});

		initManualFormat(field);
	});

	document.querySelectorAll('.js-datepickers').forEach(el => {
		const fieldStart = el.querySelector('.js-datepicker-start');
		const fieldEnd = el.querySelector('.js-datepicker-end');
		if (!fieldStart && !fieldEnd) return;

		let startDate, endDate;

		const options = {
			minDate: new Date(),
			keyboardInput: false,
			bound: true,
			format,
		}

		if (el.getAttribute('data-theme') == 'pikaday--bm') {
			options.minDate = null;
			options.numberOfMonths = getCurrentDevice() != 'mobile' ? 2 : 1;
			options.theme = 'pikaday--bm';
			options.container = el
		}

		const updateStartDate = () => {
			startPicker.setStartRange(startDate);
			endPicker.setStartRange(startDate);
			endDate = moment(startDate).add('1','day')._d;
			endPicker.setMinDate(endDate);
			endPicker.setDate(endDate);
			startPicker.setEndRange(endDate);

			startPicker.hide();
			endPicker.show();
		}

		const updateEndDate = () => {
			startPicker.setEndRange(endDate);
			endPicker.setEndRange(endDate);
			endPicker.draw();

			endPicker.hide();
		}

		const startPicker = new Pikaday({
			field: fieldStart,
			container: fieldStart.parentNode,
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					startDate = this.getDate();
					updateStartDate();

					setTimeout(function() {
						const nextDate = moment(startDate).add(1, 'days');
						const selectedMonth = nextDate.month();
						const selectedYear = nextDate.year();

						$(fieldEnd).val(nextDate.format(format));
						endPicker.setEndRange(startDate._d);
						endPicker.gotoMonth(selectedMonth);
						endPicker.gotoYear(selectedYear);

						$(fieldEnd).focus();
					}, 10);
				}
			}
		});

		const endPicker = new Pikaday({
			field: fieldEnd,
			container: fieldEnd.parentNode,
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					endDate = this.getDate();
					updateEndDate();
				}
			}
		});

		const _startDate = startPicker.getDate();
		const _endDate = endPicker.getDate();

		if (_startDate) {
			startDate = _startDate;
			updateStartDate();
		}
		if (_endDate) {
			endDate = _endDate;
			updateEndDate();
		}

		initManualFormat(fieldStart);
		initManualFormat(fieldEnd);
	});
};
